import { EquipmentTypeahead } from '~hooks/useEquipment/models';

export function getEquipmentLabel(equipment: EquipmentTypeahead) {
  if (!equipment) {
    return '';
  }

  return `${equipment?.companyShare?.externalId || equipment?.name} • ${equipment?.equipmentType?.name}`;
}
